import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {VideoObject} from '../models/video-model';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ControllersService {

    constructor(private http: HttpClient) {
    }

    public getVideoInfo(secret: string): Observable<VideoObject> {
        const params = new FormData();
        params.append('secret', secret);

        return this.http.post(environment.serverUrl + 'player-controllers/getVideoInfo.php',
            params).pipe(map(value => {
                const data: any = value['data'.toString()];

                return new VideoObject(data);
        }));
    }

    public sendStatistics(videoId: number, secret: string, type: 'start' | '0' | '25' | '50' | '75' | '100'): Observable<any> {
        const location = (window.location != window.parent.location) ? document.referrer : document.location.href;

        const params = new FormData();
        params.append('video_id', String(videoId));
        params.append('secret', secret);
        params.append('type', type);
        params.append('location', location);

        return this.http.post(environment.serverUrl + 'player-controllers/sendStatistics.php',
            params);
    }
}
